export const getApiBaseUrl = () => {
  const raw = process.env.REACT_APP_API_URL;
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  return trimmed.replace(/\/$/, "");
};
